import { get, post } from '@/utils/request'

// 请求商品列表的 demo
export function getProductList(params = {}) {
  return post('/product-manage/page-list', params)
}

// 商品分类
export function getProductCategory(params = {}) {
  return get('/product-category/get-tree', params)
}

// 热门搜索
export function hotSearchKeywords(params = {}) {
  return post('/hot-keywords/page', params)
}

// 收藏
export function addFavorite(params = {}) {
  return post('/favorites/add', params)
}

// 取消收藏
export function deleteFavorite(params = {}) {
  return post('/favorites/delete-favorites', params)
}

// 获取收藏状态
export function findByProductId(params = {}) {
  return post('/favorites/find-by-product-id', params)
}

// 购物车列表
export function shoppingCartPage(params = {}) {
  return post('/shopping-cart/page-list', params)
}

// 加入购物车/立即订购
export function addCartCart(params = {}) {
  return post('/shopping-cart/add-cart', params)
}

// 删除购物车
export function deleteCartCart(params = {}) {
  return post('/shopping-cart/deleteByIdList', params)
}

// 购物车管理接口----更新购买数量
export function shoppingUpdateQuantity(params = {}) {
  return post("/shopping-cart/update-quantity", params);
}

// 购物车管理接口----修改规格
export function shoppingUpdateSpecifications(params = {}) {
  return post("/shopping-cart/update-specifications", params);
}

// 购物车管理接口----批量下单/批量立即订购
export function shoppingAddCartBatch(params = {}) {
  return post("/shopping-cart/add-cart-batch", params);
}

// 获取登录用户购物车总数
export function shoppingCartGetCount(params = {}) {
  return get('/shopping-cart/get-count', params)
}

// 查询购物车详情
export function findCartCart(params = {}) {
  return get(`/shopping-cart/findById/${params.id}`);
}

// 查询商品详情
export function getProductDetail(params = {}) {
  return get(`/product-manage/findProductById/${params.id}`, params);
}

// 添加对比
export function productComparisonAdd(params = {}) {
  return post('/product-comparisons/add', params)
}

// 取消对比
export function productComparisonDelete(params = {}) {
  return post('/product-comparisons/delete-product-comparisons', params)
}

// 获取对比列表
export function productComparisonGet(params = {}) {
  return post('/product-comparisons/get-product-comparisons', params)
}

// 获取产品选型列表
export function productSelectionsGetList(params = {}) {
  return get('/product-selections/get-list');
}

// 购物车校验协议
export function orderCheckOrder(params = {}) {
  return post('/order/check-order', params)
}

// 下单前预算费用
export function orderPreviewOrder(params = {}) {
  return post('/order/preview-order', params)
}

// 提交订单
export function saveOrder(params = {}) {
  return post('/order/save-order', params)
}